"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=event.emitter.interface.js.map